export default {"src":"/_next/static/media/icon_flag_en.4fcad508.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};